import axios from 'axios'

import i18n from '../../i18n'
import { alertService } from '../utils/alerts'

const ConstructError = response => {
  if (typeof response?.data === 'string' && response?.data !== '')
    return response.data
  if (response?.data?.Message) return response.data.Message
  if (response?.data?.message) return response.data.message
  if (response?.data?.messages && response.data.messages.length > 0) {
    return response.data.messages[0]
  }
  return 'The server sent a undefined error request'
}

// setup default client
const client = axios.create({
  baseURL: window.env.REACT_APP_API || process.env.REACT_APP_API || '/api'
  // responseType: 'json'
})

// merge every request with default headers
const mergeCommonHeaders = rest => {
  const authToken = localStorage.getItem('authToken')
  return {
    ...rest,
    Authorization: `Bearer ${authToken}`
  }
}
client.interceptors.request.use(request => {
  request.headers = mergeCommonHeaders(request.headers)

  return request
})

let isHandling401 = false

// intercept server response before sending to request function
client.setupInterceptors = () => {
  client.interceptors.response.use(
    success => {
      return {
        data: success.data,
        success: true
      }
    },
    error => {
      // Only the pages from the SmartProtectedRoute don't create the authUser, so if don't have authUser, we can assume the user is not logged in
      const authToken = localStorage.getItem('authToken')
      const authUser = localStorage.getItem('authUser')

      if (!authToken && !authUser && !(error?.response?.status === 401 || error?.response?.status === 403)) {
        if (error?.response?.status !== 406 && error.response.status !== 401) {
          console.error(ConstructError(error?.response))
          alertService.error({
            heading: 'An error ocurred',
            message: ConstructError(error?.response)
          })
          throw new Error(error)
        }
      }

      if (
        error &&
        error.response &&
        error.response.status === 401 &&
        !isHandling401
      ) {
        isHandling401 = true
        const authToken = localStorage.getItem('authToken')
        if (authToken) {
          alertService.error({
            heading: i18n.t('SESSION_EXPIRED'),
            message: i18n.t('SESSION_EXPIRED_MESSAGE')
          })
        }
        console.log(error)
        localStorage.clear()
        if (window.navigate) {
          window.navigate('/login')
        } else {
          // eslint-disable-next-line no-restricted-globals
          location.replace('/login')
        }
      }

      return { ...error.response, success: false }
    }
  )
}

export default client
